import "./dependencies/bootstrap/bootstrap.min.css";
import "./dependencies/bootstrap/bootstrap.min.js";
import "./dependencies/shards-dashboards.1.1.0.min.css";
import 'react-toastify/dist/ReactToastify.min.css';


import './styles/style.scss';
